import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const NumberOperators = new Set([
  'is_more_than',
  'is_less_than',
  'updated_in_last',
  'not_updated_in_last',
])

export const DateTypes = new Set(['created_at', 'date', 'date_without_checkbox', 'updated_created'])
export const DateTimeTypes = new Set(['date_time', 'date_time_shortcode'])
export const DatePickerTypes = new Set([...DateTypes.values(), ...DateTimeTypes.values()])

export const isDateTextWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  !!filterItem.operator &&
  DatePickerTypes.has(filterItem.type) &&
  NumberOperators.has(filterItem.operator.key)
